import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { ToastProvider } from './contexts/ToastContext'
import { ToastContainer } from './components/Toast'
import { ProtectedRoute } from './components/ProtectedRoute'
import { Layout } from './components/Layout'
import { LoginPage } from './pages/LoginPage'
import { LoginCallback } from './pages/LoginCallback'
import { ProjectDashboard } from './pages/ProjectDashboard'
import { NewTicket } from './pages/NewTicket'
import { TicketDetail } from './pages/TicketDetail'
import { ProjectRedirect } from './pages/ProjectRedirect'
import { AdminDashboard } from './pages/AdminDashboard'
import { AdminTicketDetail } from './pages/AdminTicketDetail'
import { HelpCenter } from './pages/HelpCenter'
import { HelpArticle } from './pages/HelpArticle'
import { LlamigoWidget } from './components/LlamigoWidget'

export default function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
      <AuthProvider>
        <Routes>
          {/* Public */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/login/callback" element={<LoginCallback />} />

          {/* Protected */}
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            {/* Smart redirect: staff → /admin, client → first project */}
            <Route index element={<ProjectRedirect />} />

            {/* Admin routes (LlamAssist staff, @llamassist.ai) */}
            <Route path="admin" element={<AdminDashboard />} />
            <Route path="admin/tickets/:ticketId" element={<AdminTicketDetail />} />

            {/* Help Center */}
            <Route path="help" element={<HelpCenter />} />
            <Route path="help/:articleId" element={<HelpArticle />} />

            {/* Customer routes (project-scoped) */}
            <Route path=":projectSlug" element={<ProjectDashboard />} />
            <Route path=":projectSlug/new" element={<NewTicket />} />
            <Route path=":projectSlug/tickets/:ticketId" element={<TicketDetail />} />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <LlamigoWidget />
      </AuthProvider>
      <ToastContainer />
      </ToastProvider>
    </BrowserRouter>
  )
}
